import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {catchError, map, mergeMap, switchMap} from "rxjs/operators";
import {fromFetch} from "rxjs/fetch";
import ApiUrl from "../api/ApiUrl";
import {
    SSO_TOKEN_USER_LOGIN,
    SSOTokenWorkforceOneLoginAction,
    WorkforceOneUserHasLoggedIn,
    WorkforceOneUserLoginFailed,
} from "../actions/WorkforceOneLoginActions";

const WorkforceOneSSOTokenUserLoginEpic:  Epic<AppActions, AppActions, AppState> = (action$, state$ ) => {
    return action$.pipe(
        ofType(SSO_TOKEN_USER_LOGIN),
        mergeMap((action:AppActions) => {
                const loginDetailFromAction = action as SSOTokenWorkforceOneLoginAction
                const { ssoToken } =  loginDetailFromAction.payload
                const body = JSON.stringify(loginDetailFromAction.payload)
                return fromFetch(`${ApiUrl()}FFOrderAccount/SSOTokenLogin`,
                    {
                        method: 'POST',
                        credentials: 'omit',
                        body: body,
                        headers: {
                            "IsMarketPlace": "true",
                            'Agent': 'Chrome',
                            "api_version": "1.0",
                            "Accept": "application/json",
                            "Content-Type": "application/json"
                        },
                    })
                    .pipe(switchMap(response => response.ok ?
                        response.json():
                        Promise.resolve(null)),
                        catchError(err => {
                            console.error(err);
                            return Promise.resolve(null);
                        })
                        )
                    .pipe(map(json => json != null ?
                        WorkforceOneUserHasLoggedIn(json.data.AuthToken, json.data.UserLoginID, ssoToken, json.data) :
                        WorkforceOneUserLoginFailed()))
            }
        )
    );
};
export default WorkforceOneSSOTokenUserLoginEpic;
